import { useMutation, useQueryClient } from "react-query";
import axios from "../axios";
import { AddBundlingResponse } from "../../constants/types";

const createBundling = async (formData: FormData) => {
    const response = await axios.post<AddBundlingResponse>(
        "api/item/bundling",
        formData,
        { headers: { "Content-Type": "multipart/form-data" } },
    );
    return response.data;
};

export default function useCreateBundling() {
    const queryClient = useQueryClient();

    return useMutation((formData: FormData) => createBundling(formData), {
        onSuccess: () => {
            queryClient.invalidateQueries(["item"]);
        },
    });
}
